module.exports = __webpack_public_path__ + "media/megamenu/Books-656ce45e.jpg";